import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteMenu from './SiteMenu';
import SiteTopBar from './SiteTopBar';
import { isHomePath } from '../../navigation/paths';

const MainLayout: React.FC = () => {
  const { pathname } = useLocation();
  const isHome = isHomePath(pathname);

  return (
    <>
      {!isHome && <SiteTopBar visible />}
      <Outlet />
      <SiteMenu />
    </>
  );
};

export default MainLayout;
